enum NodeTypeEnum {
  REPORTING_UNIT = 'Reporting Unit',
  REPORTING_GROUP = 'Reporting Group',
  RESTAURANT = 'Restaurant',
  USER = 'User',
}

export default NodeTypeEnum;
